export interface SocialPreviewImage {
  imageHeightOG: number;
  imageOG: string;
  imageTypeOG: "image/webp";
  imageWidthOG: number;
}

const siteUrl = "https://alenalobacheva.com";

const socialPreview = (filename: string, width: number, height: number): SocialPreviewImage => ({
  imageHeightOG: height,
  imageOG: `${siteUrl}/social-previews/${filename}`,
  imageTypeOG: "image/webp",
  imageWidthOG: width,
});

export const socialPreviews = {
  about: socialPreview("about-alena-lobacheva.webp", 2048, 2048),
  blog: socialPreview("photography-blog.webp", 1600, 1067),
  blogFortTryon: socialPreview("blog-fort-tryon-fall-session.webp", 717, 478),
  contact: socialPreview("contact-charlotte-photographer.webp", 1600, 1067),
  home: socialPreview("home-newborn-photographer.webp", 1600, 1068),
  pricing: {
    baby: socialPreview("pricing-baby.webp", 1600, 1067),
    family: socialPreview("pricing-family.webp", 600, 400),
    maternity: socialPreview("pricing-maternity.webp", 1600, 1167),
    newborn: socialPreview("pricing-newborn.webp", 1600, 1066),
  },
  gallery: {
    baby: socialPreview("gallery-baby.webp", 1600, 1066),
    christening: socialPreview("gallery-christening.webp", 1600, 1067),
    discharge: socialPreview("gallery-discharge.webp", 1600, 1067),
    family: socialPreview("gallery-family.webp", 1600, 1067),
    maternity: socialPreview("gallery-maternity.webp", 1600, 1067),
    newborn: socialPreview("gallery-newborn.webp", 1600, 1067),
    woman: socialPreview("gallery-woman.webp", 1600, 1067),
  },
  resources: {
    index: socialPreview("resources-photography-guides.webp", 1672, 941),
    hub: {
      baby: socialPreview("resources-baby-guides.webp", 3302, 2201),
      family: socialPreview("resources-family-guides.webp", 3302, 2201),
      maternity: socialPreview("resources-maternity-guides.webp", 3302, 2201),
      newborn: socialPreview("resources-newborn-guides.webp", 1600, 800),
    },
    article: {
      "best-age-for-newborn-photos": socialPreview("guide-newborn-best-age.webp", 1600, 800),
      "how-to-prepare-for-your-newborn-session": socialPreview("guide-newborn-session-preparation.webp", 1600, 800),
      "in-home-newborn-photography": socialPreview("guide-in-home-newborn-photography.webp", 1600, 800),
      "newborn-photography-safety": socialPreview("guide-newborn-photography-safety.webp", 1042, 683),
      "what-happens-during-a-newborn-session": socialPreview("guide-newborn-session-process.webp", 1600, 800),
      "how-to-prepare-for-your-baby-photo-session": socialPreview("guide-baby-session-preparation.webp", 3302, 2201),
      "what-happens-during-a-baby-photography-session": socialPreview("guide-baby-session-process.webp", 3302, 2201),
      "what-is-the-best-age-for-baby-photos": socialPreview("guide-baby-best-age.webp", 3302, 2201),
      "how-to-prepare-for-your-maternity-photo-session": socialPreview(
        "guide-maternity-session-preparation.webp",
        3302,
        2201
      ),
      "what-to-wear-for-maternity-photos": socialPreview("guide-maternity-what-to-wear.webp", 3302, 2201),
      "when-is-the-best-time-to-take-maternity-photos": socialPreview("guide-maternity-best-time.webp", 3302, 2201),
      "best-time-of-day-for-family-photos": socialPreview("guide-family-best-time-of-day.webp", 3302, 2201),
      "how-to-prepare-for-your-family-photo-session": socialPreview(
        "guide-family-session-preparation.webp",
        3302,
        2201
      ),
      "how-to-prepare-kids-for-family-photos": socialPreview("guide-family-prepare-kids.webp", 3302, 2201),
      "what-to-wear-for-family-photos": socialPreview("guide-family-what-to-wear.webp", 3302, 2201),
    },
  },
} as const;
